module.exports = __webpack_public_path__ + "static/media/noun_Clothes_3460965.ee8360fe.png";